import React from 'react';

import { ITopicFilterState } from 'components/TopicFilters/shared';
import { CustomRegionFilterType } from './entityContext';

export interface ITopLists {
  type: string;
  topic: string;
  filters?: ITopicFilterState;
  customRegionFilter?: CustomRegionFilterType;
}

export const TopListsContext = React.createContext<ITopLists>({
  type: 'worldwide',
  topic: [] as any,
  filters: undefined,
  customRegionFilter: undefined,
});
